import React, { forwardRef } from 'react';
import { AlertProps } from '@material-ui/lab';

import { Icon } from '../icon/Icon';

import { useTranslations } from 'shared/hooks';
import { StyledAlert } from './Alert.styles';

// @ts-expect-error - forwardRef type conflict with React.FC in React 18
export const Alert: React.FC<AlertProps> = forwardRef(({ children, iconMapping = {}, ...props }, ref) => {
  const { message } = useTranslations(children);

  return (
    // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
    <StyledAlert
      {...props}
      iconMapping={{
        success: <Icon icon="CheckCircle" />,
        error: <Icon icon="Error" />,
        warning: <Icon icon="Error" />,
        ...iconMapping,
      }}
      ref={ref}
    >
      {message}
    </StyledAlert>
  );
});
